import React from 'react';
import moment from 'moment-timezone';
import { Range } from 'immutable';
import TimeUtil from 'time';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import VerticalValueSelector from 'shared/components/form/verticalValueSelector.jsx';

/**
 * Basic Duration Picker
 *
 */
const DurationPicker = React.createClass({
  displayName: 'DurationPicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    onClose: React.PropTypes.func,
    mobile: React.PropTypes.bool,
  },

  getInitialState() {
    return {
      originalValue: this.props.value,
    };
  },

  render() {
    const {
      value,
      // mobile,
      displayType,
    } = this.props;

    const positiveValue = value > 0 ? value : 0;

    let duration = moment.duration(positiveValue, 'seconds');

    // Hours
    const hours = duration.hours();
    duration = hours ? duration : duration.subtract(hours, 'hours');

    // Minutes
    let minutes = duration.minutes();

    if (displayType === TimeDisplayTypes.clockTime) {
      minutes =
        value === 0 ? duration.minutes() : Math.floor(duration.asMinutes());
    }

    duration = minutes ? duration : duration.subtract(minutes, 'minutes');

    // Seconds
    const seconds = duration.seconds();
    // let durationClasses = 'duration-picker';

    let durationClass = 'humanized-time';
    let maxDurationMinuteValue = 60;
    if (displayType === TimeDisplayTypes.clockTime) {
      durationClass = 'clock-time';
      maxDurationMinuteValue = 1440;
    }

    return (
      <span className={durationClass}>
        {displayType === TimeDisplayTypes.clockTime
          ? null
          : this._getSelectorNode('h', hours, 24, (value) =>
              this._handleChange('hours', value),
            )}
        {this._getSelectorNode('m', minutes, maxDurationMinuteValue, (value) =>
          this._handleChange('minutes', value),
        )}
        {this._getSelectorNode('s', seconds, 60, (value) =>
          this._handleChange('seconds', value),
        )}
      </span>
    );
  },

  _getSelectorNode(prefix, value, max, onChange) {
    const { mobile, displayType, onClose, onTab } = this.props;

    let fourDigitMinuteField = false;

    if (displayType === TimeDisplayTypes.clockTime) {
      fourDigitMinuteField = true;
    }

    const options = Range(0, max);

    let inputLength = 2;

    if (prefix === 'm' && fourDigitMinuteField) {
      inputLength = 4;
    }

    const focus = fourDigitMinuteField ? 'm' : 'h';

    return (
      <VerticalValueSelector
        initialFocus={prefix === focus}
        textInput
        typePrefix={prefix}
        mobile={mobile}
        onBlur={onClose}
        onTab={onTab}
        onChange={onChange}
        options={options}
        displayValue={TimeUtil.getFormattedDurationField(value)}
        value={value}
        length={inputLength}
      />
    );
  },

  _handleChange(type, amount) {
    const { value, displayType } = this.props;

    const positiveValue = value > 0 ? value : 0;

    const oldDuration = moment.duration(positiveValue, 'seconds');
    let newDuration = moment.duration(parseInt(amount, 10), type);

    const oldHours = oldDuration.hours();
    const oldMins = oldDuration.minutes();
    const oldSeconds = oldDuration.seconds();

    let oldHourDuration = moment.duration(oldHours, 'hours');
    const oldMinDuration = moment.duration(oldMins, 'minutes');
    const oldSecDuration = moment.duration(oldSeconds, 'seconds');

    if (type === 'minutes' && displayType === TimeDisplayTypes.clockTime) {
      oldHourDuration = 0;
    }

    if (type === 'hours') {
      newDuration = newDuration.add(oldMinDuration).add(oldSecDuration);
    } else if (type === 'minutes') {
      newDuration = newDuration.add(oldHourDuration).add(oldSecDuration);
    } else if (type === 'seconds') {
      newDuration = newDuration.add(oldHourDuration).add(oldMinDuration);
    }

    this.props.onChange(newDuration.asSeconds());
  },
});

export default DurationPicker;
